import { resolveTraits } from '../helpers/resolve-traits.js';
/** Merge operation traits in order, while keeping operation fields highest priority. */
export const resolveOperationWithTraits = (operation) => resolveTraits(operation, operation.traits ?? []);
